import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  noWrap: {
    whiteSpace: 'nowrap',
  },
  textLabel: {
    maxWidth: '300px',
  },
  leftButton: {
    marginRight: theme.spacing(3),
  },
  fullWidth: {
    width: '100%',
    maxWidth: '250px',
  },
  inputContainer: {
    marginRight: theme.spacing(4),
  },
}));

export default useStyles;
